import { SvgIcon, Text, useText } from "@sveabank/cc-common";

const SigningCompleteSection: React.FC = () => {
	const [t, texts] = useText();
	return (
		<div className="flex flex-row justify-end gap-4 py-4">
			<SvgIcon imageSrc="SIGN_DONE" height={42} />
			<Text className="flex flex-wrap content-center">{t(texts.signPage.completedSigning)}</Text>
		</div>
	);
};

export default SigningCompleteSection;
